import axios from "axios";
import cookie from "react-cookies";
import { Fragment, useEffect, useState } from "react";
import { CURRENT_OR_PAST, PERIODS_FOR_STATS } from "../../../../constants/periods.for.stats";
import generateStatsDates from "../../../../scripts/helpers/generate.stats.dates";
import numberSpaces from "../../../../scripts/helpers/numbers.with.spaces";
import prettyFloat from "../../../../scripts/helpers/pretty.float";
import ToggleSlider from "../../inputs/toggleslider";
import Selectfield from "../../inputs/selectfield";
import Textfield from "../../inputs/textfield";
import API from "../../../../constants/api";
import useGlobal from "../../../../store";
import "./stats.list.scss";

const MAIN_STATS = [

  {anchor: "reg_count", title: "Общее кол-во регистраций"},
  {anchor: "auth_next_day_count", title: "Из них зашли на следующий день"},
  {anchor: "auth_after_demo_period_count", title: "Из них зашли после демо-периода"},
  {anchor: "pay_month_count", title: "Кол-во оплат за месяц"},
  {anchor: "pay_sixmonts_count", title: "Кол-во оплат за пол-года"},
  {anchor: "pay_year_count", title: "Кол-во оплат за год"},
  {anchor: "pay_repay_count", title: "Кол-во повторных оплат тарифа"},
  {anchor: "ai_tokens_payments_count", title: "Кол-во оплат ИИ-токенов"},
  {anchor: "fail_payments_count", title: "Кол-во неудачных оплат"},
  {anchor: "re_visit_count", title: "Кол-во повторных посещений"},
  {anchor: "tariff_screen_view_count", title: "Кол-во увидели страницу тарифа"},
  {anchor: "tariff_custdev_click_count", title: "Кол-во переходов на CustDev анкету"},
  {anchor: "custdev_count", title: "Кол-во заполнили CustDev анкету"},

];

const MONEY_STATS = [

  {anchor: "tariff_money_sum", title: "Сумма оплат тарифа"},
  {anchor: "ai_tokens_money_sum", title: "Сумма оплат ИИ-токенов"},
  {anchor: "all_money_sum", title: "Сумма всех оплат"},

];

const FROM_WHERE_STATS = [

  {anchor: "reg_from_direct_count", title: "Регистраций с Я.Директа"},
  {anchor: "reg_from_vk_ads_count", title: "Регистраций с VK Ads"},
  {anchor: "reg_from_seo_count", title: "Регистраций с поисковиков"},
  {anchor: "reg_from_youtube_count", title: "Регистраций с YouTube"},
  {anchor: "reg_from_habr_qna_count", title: "Регистраций с Habr Q&A"},
  {anchor: "reg_from_vc_count", title: "Регистраций с VC"},
  {anchor: "reg_from_chatgpt_count", title: "Регистраций с ChatGPT"},
  {anchor: "reg_from_mainpage_count", title: "Регистраций с главной страницы"},
  {anchor: "reg_from_otherpages_count", title: "Регистраций с остальных страниц"},
  {anchor: "mobile_count", title: "Кол-во пользователей с мобильных устройств"},

];


const OTHER_STATS = [

  {anchor: "schemes_count", title: "Создано проектов"},
  {anchor: "schemes_tables_count", title: "Создано таблиц в этих проектах"},

];

const AI_STATS = [

  {anchor: "ai_messages_count", title: "Кол-во сообщений пользователю к ИИ"},
  {anchor: "ai_messages_average_per_user", title: "Среднее количество сообщений к ИИ на пользователя в выбранном промежутке"},
  {anchor: "ai_messages_tokens_count", title: "Кол-во потраченных ИИ-токенов"},
  {anchor: "ai_positive_feedbacks", title: "Кол-во принятых ответов ИИ"},
  {anchor: "ai_negative_feedbacks", title: "Кол-во отклоненных ответов ИИ"},

];



const StatsList = () => {

  const [ globalState, globalActions ] = useGlobal();
  const { dummy } = globalState;
  const { updateRender } = globalActions;

  const [ statsPeriod, setStatsPeriod ] = useState(PERIODS_FOR_STATS[0].id)
  const [ statsCurrent, setStatsCurrent ] = useState(CURRENT_OR_PAST[0].id)

  const [ isLoading, setLoading ] = useState({});
  const [ stats, setStats ] = useState({});
  const [ dateFrom, setDateFrom ] = useState('');
  const [ dateTo, setDateTo ] = useState('');

  async function getStats() {

    try {

      setLoading( true );
      const token = cookie.load('token');

      if ( !token ) { throw('Токен не найден'); }

      let date_from = '';
      let date_to = '';

      if ( statsPeriod?.id === 'period' ) {

        date_from = dateFrom;
        date_to = dateTo;

      } else {

        const gsd = generateStatsDates( statsPeriod, statsCurrent );
        updateRender();
        setDateFrom(gsd.date_from);
        setDateTo(gsd.date_to);
        date_from = gsd.date_from;
        date_to = gsd.date_to;

      }

      const { data } = await axios.post( API.statistic.users, {

        token,
        date_from,
        date_to,

      });

      setLoading( false );

      if ( !data?.success ) { throw( data?.error || data?.message || 'Не удалось получить статистику' ); }

      setStats( data );

    } catch ( err ) {

      console.error( 'StatsList getStats error', err );
      setLoading( false );
      setStats({});
      globalActions.sign.Logout();

    }

  }

  async function getStatsByPeriod() {

    if (!( dateFrom.length === 10 && dateTo.length === 10 )) { return; }
    return getStats();

  }

  useEffect(() => {

    console.log('statsPeriod', statsPeriod);
    getStats();
    
  }, [ statsPeriod, statsCurrent ]);

  return (

    <div className = "statslist">

      <span style = {{ display: 'none' }}>{ dummy }</span>

      <div className = "statslist__period">

        <Selectfield
        
          list = { PERIODS_FOR_STATS }
          selected = { statsPeriod }
          select = { setStatsPeriod }

        />

        {( statsPeriod.id === 'week' || statsPeriod.id === 'month' || statsPeriod.id === 'year' ) && 
        
          // <Selectfield
          
          //   list = { CURRENT_OR_PAST }
          //   selected = { statsCurrent }
          //   select = { setStatsCurrent }

          // />

          <ToggleSlider

            list = { CURRENT_OR_PAST }
            selected = { statsCurrent }
            select = { setStatsCurrent }
            style = {{ maxWidth: '300px' }}

          />

        }

        { statsPeriod.id === 'period' ? (
        
          <div className = "statslist__period__duration">

            <div className = "statslist__period__duration__block">

              <div className = "statslist__period__duration__block__text">от</div>

              <Textfield

                type = 'text'
                value = { dateFrom }
                set = { setDateFrom }
                placeholder = { "YYYY-MM-DD" }
                onBlur = { getStatsByPeriod }
                onKeyUp = { e => { if ( e.key === 'Enter' ) { getStatsByPeriod(); } } }

              />

            </div>

            <div className = "statslist__period__duration__block">

              <div className = "statslist__period__duration__block__text">до</div>

              <Textfield

                type = 'text'
                value = { dateTo }
                set = { setDateTo }
                placeholder = { "YYYY-MM-DD" }
                onBlur = { getStatsByPeriod }
                onKeyUp = { e => { if ( e.key === 'Enter' ) { getStatsByPeriod(); } } }

              />

            </div>

          </div>

        ) : (
          // <><br/>{ JSON.stringify( form, 0, 2 ) }</> 
          <><br/>{ dateFrom } – { dateTo }</> 
        )}

      </div>

      { isLoading ? <p>Загружаю...</p> : 
      
        <Fragment>

          { MAIN_STATS.map(( { title, anchor }, index ) => (

            <div className = "statslist__row" key = { index }>

              <div className = "statslist__row__title">{ title }</div>
              <div className = "statslist__row__amount">{ ( stats?.[ anchor ] || stats?.[ anchor ] === 0 ) ? numberSpaces( stats[ anchor ] ) : '–' }</div>

            </div>

          ))}

          <hr style = {{ margin: '20px 0' }} />

          { MONEY_STATS.map(( { title, anchor }, index ) => (

            <div className = "statslist__row" key = { index }>

              <div className = "statslist__row__title">{ title }</div>
              <div className = "statslist__row__amount">{ ( stats?.[ anchor ] || stats?.[ anchor ] === 0 ) ? numberSpaces( prettyFloat( stats[ anchor ] ) ) : '–' }</div>

            </div>

          ))}

          <hr style = {{ margin: '20px 0' }} />

          { OTHER_STATS.map(( { title, anchor }, index ) => (

            <div className = "statslist__row" key = { index }>

              <div className = "statslist__row__title">{ title }</div>
              <div className = "statslist__row__amount">{ ( stats?.[ anchor ] || stats?.[ anchor ] === 0 ) ? numberSpaces( stats[ anchor ] ) : '–' }</div>

            </div>

          ))}

          <hr style = {{ margin: '20px 0' }} />

          { FROM_WHERE_STATS.map(( { title, anchor }, index ) => (

            <div className = "statslist__row" key = { index }>

              <div className = "statslist__row__title">{ title }</div>
              <div className = "statslist__row__amount">{ ( stats?.[ anchor ] || stats?.[ anchor ] === 0 ) ? numberSpaces( stats[ anchor ] ) : '–' }</div>

            </div>

          ))}

          <hr style = {{ margin: '20px 0' }} />

          { AI_STATS.map(( { title, anchor }, index ) => (

            <div className = "statslist__row" key = { index }>

              <div className = "statslist__row__title">{ title }</div>
              <div className = "statslist__row__amount">{ ( stats?.[ anchor ] || stats?.[ anchor ] === 0 ) ? numberSpaces( stats[ anchor ] ) : '–' }</div>

            </div>

          ))}

        </Fragment>

      }

    </div>

  );

}

export default StatsList;